import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import MainTheme from './theme';
import Header from '../header';
import Footer from '../footer';
import styles from './styles';

const MainLayout = props => {
	const {
		children, classes, title, handleGoBack, isHomepage, hideHeaderControls
	} = props;

	return (
		<MainTheme>
			<Header
				title={title}
				classes={{container: classes.header}}
				handleGoBack={handleGoBack}
				isHomepage={isHomepage}
				hideControls={hideHeaderControls}
			/>
			<div className={classes.overlay}>
				<Paper
					square
					classes={{
						shadow2: classes.removePaperShadow, // if it's not desktop
						root: classes.content
					}}
				>
					{children}
				</Paper>
				<Footer classes={{container: classes.footer}}/>
			</div>
		</MainTheme>
	);
};

MainLayout.propTypes = {
	classes: PropTypes.object.isRequired,
	children: PropTypes.node.isRequired,
	isHomepage: PropTypes.bool.isRequired,
	handleGoBack: PropTypes.func.isRequired,
	hideHeaderControls: PropTypes.bool,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	])
};

MainLayout.defaultProps = {
	title: (<img width="133" height="40" src="/assets/logo.svg" alt="Juvora | Guide"/>)
};

export default withStyles(styles)(MainLayout);



// WEBPACK FOOTER //
// ./src/client/components/main/layout/layout.jsx